var bootstrap = require('bootstrap');
document.addEventListener('DOMContentLoaded', () => {
  console.log('here');
  const modal = document.getElementById('external-modal');
  const cancelBtn = document.getElementById('modal-cancel');
  const proceedBtn = document.getElementById('modal-proceed');
  
  const currentHostname = window.location.hostname;

  // Add the domains you want to skip the pop-up warning here
  const excludedDomains = [
    'olb-ebanking.com', // Removed trailing slash to prevent hostname string matching issues
    'gecu.com',
    'bosw.com',
    'bankofsw.com'
  ];

  document.body.addEventListener('click', (e) => {
    const link = e.target.closest('a');
    
    // Safety check: ensure we didn't just click the proceed button inside the modal
    if (link === proceedBtn) {
      return;
    }
    
    if (link && link.href && !link.href.startsWith('mailto:') && !link.href.startsWith('tel:')) {
      const isExternal = link.hostname !== currentHostname;
      // Checks if the clicked link's hostname matches any entry in your excluded array
      const isExcluded = excludedDomains.some(domain => link.hostname === domain || link.hostname.endsWith('.' + domain));

      if (isExternal && !isExcluded) {
        e.preventDefault(); // Stop immediate navigation
        
        // Pass the target to the proceed button and force a new tab
        proceedBtn.href = link.href;
        proceedBtn.target = '_blank';
        proceedBtn.rel = 'noopener noreferrer'; // Security best practice
        
        // Show modal
        modal.style.display = 'flex';
        modal.setAttribute('aria-hidden', 'false');
      }
    }
  });

  // Only close immediately when canceling or clicking the background
  cancelBtn.addEventListener('click', closeModal);

  // Close the modal slightly after clicking proceed so the window context has time to register the link action
  proceedBtn.addEventListener('click', () => {
    setTimeout(closeModal, 100);
  });

  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  function closeModal() {
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
  }
});
